"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndDateFromIsoDateString = exports.getDateFromScheduleTime = exports.getEndDateFromScheduleDateTime = exports.getDateFromScheduleDateTime = exports.convertLegacySchedule = exports.getScheduleTimeFromString = exports.getScheduleDateTimeFromDate = void 0;
/**
 * Convert dateString into a `ScheduleDateTime` object
 * @param dateString
 * @returns
 */
const getScheduleDateTimeFromDate = (origninalDate) => {
    const date = new Date(origninalDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return {
        day,
        month,
        year,
        hours,
        minutes
    };
};
exports.getScheduleDateTimeFromDate = getScheduleDateTimeFromDate;
/**
 * Convert timeString into a `ScheduleTime` object
 * @param dateString
 * @returns
 */
const getScheduleTimeFromString = (timeString) => {
    const date = new Date(timeString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return {
        hours,
        minutes
    };
};
exports.getScheduleTimeFromString = getScheduleTimeFromString;
/**
 * Convert legacy `Schedule` object into a new `Schedule` object
 * @param schedule
 * @returns
 */
const convertLegacySchedule = (schedule) => {
    const { ranges } = schedule;
    const newRanges = ranges.map(({ startDate, endDate, conditions }) => {
        return {
            start: getScheduleDateTimeFromDate(new Date(startDate)),
            end: getScheduleDateTimeFromDate(new Date(endDate)),
            conditions: conditions
                ? conditions.map(condition => ({
                    startTime: getScheduleTimeFromString(condition.startTime),
                    endTime: getScheduleTimeFromString(condition.endTime),
                    days: condition.days
                }))
                : []
        };
    });
    return {
        ranges: newRanges
    };
};
exports.convertLegacySchedule = convertLegacySchedule;
/**
 * Convert 'ScheduleDateTime' to 'Date.
 */
const getDateFromScheduleDateTime = ({ year, month, day, hours, minutes }) => new Date(year, month - 1, day, hours, minutes);
exports.getDateFromScheduleDateTime = getDateFromScheduleDateTime;
/**
 * Convert 'ScheduleDateTime' to end 'Date'.
 * 59 seconds and 999 milliseconds are added to end date to make sure
 * that schedule displays the full last minute.
 */
const getEndDateFromScheduleDateTime = ({ year, month, day, hours, minutes }) => new Date(year, month - 1, day, hours, minutes, 59, 999);
exports.getEndDateFromScheduleDateTime = getEndDateFromScheduleDateTime;
/**
 * Convert 'ScheduleTime' to 'Date'
 */
const getDateFromScheduleTime = ({ hours, minutes }) => {
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
};
exports.getDateFromScheduleTime = getDateFromScheduleTime;
/**
 * Convert 'isoDateString' to end 'Date'
 * 59 seconds and 999 milliseconds are added to end date to make sure
 * that schedule displays the full last minute.
 */
const getEndDateFromIsoDateString = (isoDateString) => {
    const date = new Date(isoDateString);
    date.setSeconds(59);
    date.setMilliseconds(999);
    return date;
};
exports.getEndDateFromIsoDateString = getEndDateFromIsoDateString;
//# sourceMappingURL=schedule.js.map